import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FHEDivider } from 'data/components';

class TableDetails extends PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        userId: PropTypes.number.isRequired,
        icon: PropTypes.object.isRequired,
        table: PropTypes.func.isRequired
    };
    render() {
        const { title, table: TableComponent, icon: IconComponent, userId } = this.props;

        return (
            <Fragment>
                <FHEDivider title={title} IconComponent={IconComponent} />
                <TableComponent userId={userId} />
            </Fragment>
        );
    }
}

export default TableDetails;



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/Table/TableDetails.js